const pagination = {
  perPage: 10,
  currentPage: 1,
  total: 0,
  perPageOptions: [5, 10, 20, 25, 50],
};

const functions = {
  pagedData() {
    return this.tableData2.slice(this.from, this.to);
  },
  queriedData() {
    let result = this.tableData2;
    if (this.searchQuery !== '') {
      result = this.fuseSearch.search('=' + this.searchQuery + '');
    }
    this.pagination.total = result.length;

    return result.slice(this.from, this.to);
  },
  to() {
    let highBound = this.from + this.pagination.perPage;
    if (this.total < highBound) {
      highBound = this.total;
    }

    return highBound;
  },
  from() {
    return this.pagination.perPage * (this.pagination.currentPage - 1);
  },
  total() {
    return this.pagination.total;
  },
};

export default { pagination, functions };
